var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AwsUi } from '../../../core/runtime/src';
import { KeyCode } from '../../../core/utils/src/dom';
import BemClassBuilder from '../../../core/utils/src/class-builders/bem';
import { Segment } from './segment';
import { Select } from '../../select/src';
export var SegmentedControl = AwsUi.__addComponent('awsui-segmented-control', {
    releaseStatus: 'stable',
    properties: {
        // Id of the currently selected option.
        selectedId: {
            type: 'string'
        },
        // An array of objects representing options. Each segment has the following properties:
        //
        // * `id` [string, mandatory]: id of the segment.
        // * `disabled` [boolean]: whether the segment should be disabled.
        // * `iconName` [string]: name of the icon, used with `awsui-icon`.
        // * `iconAlt` [string]: alternate text for the icon when using `iconUrl`, or `iconName` without `text`. Mandatory when using an icon without `text`.
        // * `iconUrl` [string]: URL of a custom icon.
        // * `text`    [string]: the text of a segment.
        options: {
            type: 'array',
            itemTypes: ['SegmentedControl.Option']
        },
        // Provides an aria-label for the Segmented Control
        ariaLabel: {
            type: 'string'
        },
        // Adds aria-labelledby on the component.
        ariaLabelledby: {
            type: 'string'
        }
    },
    callbacks: {
        initialized: function () {
            // Gives the current active Index where the focus should be
            this.__activeIndex = 0;
        }
    },
    events: {
        // Fired when the user selects a different segment.
        change: {
            bubbles: true,
            cancelable: false,
            detailType: 'SegmentedControl.ChangeDetail'
        }
    },
    functions: {
        __moveHighlight: function (event) {
            var _this = this;
            var enabledOptions = this.options.filter(function (option) { return !option.disabled; });
            var focusIndex = enabledOptions.indexOf(this.options[this.__activeIndex]);
            switch (event.keyCode) {
                case KeyCode.right:
                    focusIndex = (focusIndex + 1) % enabledOptions.length;
                    break;
                case KeyCode.left:
                    --focusIndex;
                    if (focusIndex === -1) {
                        focusIndex = enabledOptions.length - 1;
                    }
                    break;
                case KeyCode.tab:
                    this.__activeIndex =
                        this.selectedId === null
                            ? 0
                            : this.options.indexOf(this.options.filter(function (option) { return option.id === _this.selectedId; })[0]);
                    return;
                default:
                    return;
            }
            this.__activeIndex = this.options.indexOf(enabledOptions[focusIndex]);
            var enabledOptionNodes = this.node.querySelectorAll('.awsui-segment:not(.awsui-segment--disabled)');
            enabledOptionNodes[focusIndex].focus();
        }
    },
    render: function () {
        var _this = this;
        var cb = new BemClassBuilder({ __componentName: 'awsui-segmented-control' })
            .modifier('segment-part')
            .modifier(this.options.length + "-segments")
            .toString();
        var selectOptions = this.options.map(function (option) {
            var label = option.text || option.iconAlt;
            return __assign(__assign({}, option), { label: label });
        });
        var currentSelectedOption = selectOptions.filter(function (option) {
            return option.id === _this.selectedId;
        })[0];
        var nonDisabledSegments = this.options.filter(function (option) { return !option.disabled; });
        var currentActiveFocusIndex = this.options.indexOf(this.options.filter(function (option) { return option.id === _this.selectedId; })[0]);
        this.__activeIndex = currentActiveFocusIndex === -1 ? 0 : currentActiveFocusIndex;
        return (AwsUi.__createElement("div", { className: "awsui-segmented-control", "aria-label": this.ariaLabel, "aria-labelledby": this.ariaLabelledby },
            AwsUi.__createElement("div", { className: "awsui-segmented-control--select" },
                AwsUi.__createElement(Select, { options: selectOptions, selectedOption: currentSelectedOption, triggerVariant: "option", change: function (event) {
                        _this.__update();
                        _this.__fireEvent('change', { selectedId: event.detail.selectedOption.id });
                    } })),
            AwsUi.__createElement("div", { className: cb, onkeydown: function (event) { return _this.__moveHighlight(event); } }, this.options.map(function (option) {
                var isActive = _this.selectedId === option.id;
                var tabIndex = isActive ? 0 : -1;
                if (currentSelectedOption === null && nonDisabledSegments.indexOf(option) === 0) {
                    tabIndex = 0;
                }
                return (AwsUi.__createElement(Segment, { id: option.id, disabled: !!option.disabled, iconName: option.iconName, iconAlt: option.iconAlt, iconUrl: option.iconUrl, text: option.text, isActive: isActive, tabIndex: tabIndex, onClick: function () {
                        _this.__activeIndex = _this.options.indexOf(option);
                        if (_this.selectedId !== option.id) {
                            _this.__fireEvent('change', { selectedId: option.id });
                        }
                    } }));
            }))));
    }
});
//# sourceMappingURL=segmented-control.js.map